import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight, Clock, Users, MapPin, Baby } from "lucide-react";
import { PROGRAMS } from "../data/site";
import FinalCTA from "../components/FinalCTA";

export default function Programs() {
  return (
    <div data-testid="programs-page">
      <section className="aqua-section pb-0">
        <div className="aqua-container max-w-3xl">
          <p className="text-eyebrow">Programs</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 text-[#0B2F6B] leading-tight">
            Lessons tailored to every age and goal.
          </h1>
          <p className="mt-5 text-[#3B5878] text-base sm:text-lg leading-relaxed">
            Choose private mobile lessons in your own pool, join a small-group
            session at our Jacksonville or Surf City academy, or book certified
            private lifeguards for your next pool event.
          </p>
        </div>
      </section>

      <section className="aqua-section">
        <div className="aqua-container space-y-16">
          {PROGRAMS.map((p, idx) => (
            <motion.div
              key={p.id}
              id={p.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.5 }}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${
                idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
              data-testid={`program-${p.id}`}
            >
              <div className="lg:col-span-6">
                <div className="relative">
                  <div className="absolute -inset-3 rounded-[2rem] -z-10" style={{ backgroundColor: "#EAF3FF" }} />
                  <img src={p.image} alt={p.name} className="w-full h-[360px] sm:h-[460px] object-cover rounded-3xl shadow-md" />
                </div>
              </div>
              <div className="lg:col-span-6">
                <p className="text-eyebrow">Program 0{idx + 1}</p>
                <h2 className="font-heading text-3xl sm:text-4xl font-semibold mt-3 text-[#0B2F6B]">{p.name}</h2>
                <p className="mt-4 text-[#3B5878] text-base sm:text-lg leading-relaxed">{p.description}</p>
                <div className="mt-6 grid grid-cols-2 gap-3">
                  <Detail icon={Baby} label="Ages" value={p.ages} />
                  <Detail icon={Clock} label="Sessions" value={p.sessions} />
                  <Detail icon={Users} label="Format" value={p.format} />
                  <Detail icon={MapPin} label="Location" value={p.location} />
                </div>
                <div className="mt-6">
                  <p className="text-sm font-semibold text-[#0B2F6B] mb-3 uppercase tracking-wider">Skills you'll learn</p>
                  <ul className="space-y-2">
                    {p.skills.map((s, i) => (
                      <li key={i} className="flex items-start gap-3 text-[#0B2F6B]">
                        <Check className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#1E7BE0]" />
                        <span>{s}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-8 flex flex-wrap gap-3">
                  <Link to="/contact" className="btn-primary" data-testid={`program-cta-${p.id}`}>
                    Inquire about this program <ArrowRight className="w-4 h-4" />
                  </Link>
                  <Link to="/how-it-works" className="btn-outline">
                    See how it works
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}

function Detail({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl bg-[#EAF3FF]/70 px-4 py-3">
      <div className="flex items-center gap-2 text-[#7C93AD] text-xs uppercase tracking-wider">
        <Icon className="w-3.5 h-3.5" />
        {label}
      </div>
      <p className="mt-1 font-semibold text-[#0B2F6B]">{value}</p>
    </div>
  );
}
